import { useTranslation } from "react-i18next";

import styles from "./AboutPage.module.scss";
import { LogoCell } from "./LogoCell";
import azvo from "../../assets/images/azvo.png";
import carnet from "../../assets/images/carnet.png";
import cisoo from "../../assets/images/cisoo.png";
import esfCisoo from "../../assets/images/esf-cisoo.png";
import esf from "../../assets/images/esf.png";
import esif from "../../assets/images/esif.png";
import eu from "../../assets/images/eu.png";
import euCisoo from "../../assets/images/euCisoo.png";
import mpudt from "../../assets/images/mpudt.png";
import mzo from "../../assets/images/mzo.png";
import mzom from "../../assets/images/mzom.png";
import sduzrdd from "../../assets/images/sduzrdd.png";

export interface AboutPageProps {
  title: string;
  logo: string;
  version: string;
}

export const AboutPage = ({ title, logo, version }: AboutPageProps) => {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  const firstLogoRow = [
    { src: carnet, alt: "Carnet", imgClassName: styles.carnet },
    { src: mzom, alt: "MZO" },
    { src: azvo, alt: "AZVO" },
    {
      src: mpudt,
      alt: "MPUDT",
      imgClassName: styles.mpudt,
      divClassName: styles.mpudtCell,
    },
  ];

  const secondLogoRow = [
    { src: esfCisoo, alt: "ESF", imgClassName: styles.esfCisoo },
    { src: euCisoo, alt: "EU", imgClassName: styles.euCisoo },
    { src: esif, alt: "ESIF" },
  ];

  const thirdLogoRow = [
    { src: carnet, alt: "Carnet", imgClassName: styles.carnet },
    { src: sduzrdd, alt: "SDUŠRDD" },
    { src: mzo, alt: "MZO", imgClassName: styles.mzo },
  ];

  const fourthLogoRow = [
    { src: esf, alt: "ESF", imgClassName: styles.esf },
    { src: eu, alt: "EU", imgClassName: styles.eu },
    { src: esif, alt: "ESIF" },
  ];

  return (
    <div className={styles.about}>
      <div className={styles.row}>
        <img className={styles.logo} src={cisoo} alt="CISOO" />
      </div>

      <div className={styles.border} />

      <div className={styles.row}>
        {firstLogoRow.map((logo) => (
          <LogoCell key={logo.alt} {...logo} />
        ))}
      </div>

      <div className={styles.row}>
        {secondLogoRow.map((logo) => (
          <LogoCell key={logo.alt} {...logo} />
        ))}
      </div>

      <div className={styles.textbox_first}>
        {t("aboutPage.financedByPlus")}
      </div>

      <div className={styles.thickborder} />

      <div className={styles.row}>
        <img className={styles.logo} src={logo} alt="eUpisi logo" />
      </div>

      <div className={styles.row}>
        <div className={styles.title}>{title}</div>
      </div>

      <div className={styles.border} />

      <div className={styles.row}>
        {thirdLogoRow.map((logo) => (
          <LogoCell key={logo.alt} {...logo} />
        ))}
      </div>

      <div className={styles.row}>
        {fourthLogoRow.map((logo) => (
          <LogoCell key={logo.alt} {...logo} />
        ))}
      </div>

      <div className={styles.textbox_first}>{t("aboutPage.financedBy")}</div>

      <div className={styles.textbox_copyright}>
        <div />
        <div className={styles.textbox_first}>
          {t("aboutPage.version", { version })}
        </div>
        <div className={styles.textbox_first}>
          {t("footer.copyright", { year })} {t("footer.copyright2")}
        </div>
      </div>
    </div>
  );
};
